import * as React from "react";

export type HeaderContextType = {
  headerButtons: React.ReactNode;
  setHeaderButtons: (headerButtons: React.ReactNode) => void;
  headerName: React.ReactNode;
  setHeaderName: (headerName: React.ReactNode) => void;
  toolbarButtons: React.ReactNode;
  setToolbarButtons: (headerButtons: React.ReactNode) => void;
};

type Props = {
  children: React.ReactNode;
};

export const HeaderContext = React.createContext({} as HeaderContextType);

export function useHeader() {
  const context = React.useContext(HeaderContext);

  return context;
}

export const HeaderProvider = ({ children }: Props): JSX.Element => {
  const [headerButtons, setHeaderButtonsState] = React.useState<React.ReactNode>(null);
  const [toolbarButtons, setToolbarButtonsState] = React.useState<React.ReactNode>(null);
  const [headerName, setHeaderName] = React.useState<React.ReactNode>(null);

  function setHeaderButtons(buttons: React.ReactNode) {
    setHeaderButtonsState(buttons);
  }

  function setToolbarButtons(buttons: React.ReactNode) {
    setToolbarButtonsState(buttons);
  }

  return (
    <HeaderContext.Provider
      value={{
        headerButtons,
        setHeaderButtons,
        headerName,
        setHeaderName,
        toolbarButtons,
        setToolbarButtons,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};
